module.exports = __webpack_public_path__ + "static/media/HB3@2x.2ff52851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/HB/HB3@2x.png
// module id = 278
// module chunks = 0